<template lang="pug">
    v-card
        v-snackbar(
            v-model="snackbar"
            :timeout="10000"
            color='error'
        ) {{ snackbarMessage }}
        v-toolbar(dark dense color="red" class="navFixed" width="100%")
            v-toolbar-title i-Permit Preview    
            v-spacer
            v-toolbar-title(v-if="getApproveStatus(ip.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipWorkflow))}}
            v-toolbar-title(v-if="getApproveStatus(ip.ipWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipWorkflow))}}
            v-toolbar-items
                v-btn(v-if="dialogType !== 'creator' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                    v-icon(title="Approval") assignment_turned_in
                    | &nbsp; Approval
                v-dialog(v-if="dialogType !== 'creator' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                    v-card()
                        v-card-title(class="headline grey lighten-2") Approval Form
                        v-card-text
                            v-layout(wrap)
                                v-flex(xs12)
                                    v-radio-group(v-model="approval" row)
                                        v-radio(label="Approve" color="success" value="7")
                                        v-radio(label="Reject" color="red" value="8")
                                        v-radio(label="Need Review" color="yellow darken-4" value="3")
                                v-flex(xs12)
                                    v-textarea(
                                        v-model="comment"
                                        filled
                                        label="Comment (Optional)"
                                        value=""
                                    )
                        v-card-actions
                            v-spacer
                            v-btn(text @click.native="approvalDialog = false") Close
                            v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                            v-dialog(
                                v-model="approvalDialog2"
                                hide-overlay
                                persistent
                                width="300")
                                v-card(color="primary" dark)
                                v-card-text Processing. Please wait!
                                    v-progress-linear(indeterminate color="white" class="mb-0")
                v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                    v-icon share
                    | &nbsp; Share
                    v-dialog(v-model="share" persistent max-width="400px")
                        v-card
                            v-card-title(class="headline grey lighten-3") Share
                            v-flex(class="headline grey lighten-3")
                                v-row(no-gutters align="center" justify="center")
                                    ShareNetwork(
                                        v-for="network in networks"
                                        :key="network.key"
                                        class="ma-3 pa-3 green"
                                        :network="network.network"
                                        style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                        :url="shortenUrl"
                                        :title="sharing.title"
                                        :description="sharing.description"
                                    ) 
                                        i(:class="network.icon" style="color:white")
                                        span(class="ma-3" style="color:white") {{ network.name }}
                            v-spacer
                            v-flex(class="text-end headline grey lighten-2")
                                v-btn(color="blue darken-1" text @click.native="share = false") Close
                v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                    v-icon print
                    | &nbsp; Print
                    v-dialog(v-model="print" persistent max-width="400px")
                        v-card
                            v-card-title(class="headline grey lighten-3") Print Document
                            v-alert(:value='true' color="success")
                                h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                            v-flex(class="headline grey lighten-3")
                                v-row(no-gutters align="center" justify="center")
                                    v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                        i(class="far fah fa-lg fa fa-print" style="color:white")
                                        span(class="ma-3" style="color:white") Print
                                    v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                        i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                        span(class="ma-3" style="color:white") Share
                            v-spacer
                            v-flex(class="text-end headline grey lighten-2")
                                v-btn(color="blue darken-1" text @click.native="print = false") Close
                v-btn(@click.native="dialog = false" color="red" depressed)
                    v-icon(title="Close") cancel
                    | &nbsp; Close
        v-list(class="print-bg padTop60")
            div(:id="ip._id")
                .page(size="Auto")
                    div(class="view-width" style="font-size:10px;")
                        div(v-if="ip.ipStatus == 4" id="background")
                            img(src="../assets/Approve.png" class="imgWatermark")
                        div(v-else-if="ip.ipStatus == 8" id="background")
                            img(src="../assets/reject.png" class="imgWatermark")
                        table(class="view-width tableInput" style="margin-top:10px;")
                            tbody
                                tr
                                    td( class="align-center" width="150" rowspan="3")
                                        img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                    td(class="align-center") SINARMAS MINING SYSTEM
                                    td( class="align-center" width="150" rowspan="3") 
                                        img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}`" style="width:80px;margin:2px 0;")
                                tr
                                    td(class="align-center") FORMULIR
                                tr
                                    td(class="align-center") {{ formName[ip.ipForm] }}
                        
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="6") I. INFORMASI UMUM
                                tr
                                    td(width="150" class="headerTable") Judul Pekerjaan
                                    td(colspan="3") {{ ip.ipTitle }}
                                tr
                                    td(width="150" class="headerTable") Tanggal Lampiran
                                    td {{ ip.ipInspectionDate }}
                                    td(width="100" class="headerTable") Departemen
                                    td {{ ip.ipDeptDivisi }}
                                tr
                                    td(class="headerTable") Nomor Lampiran
                                    td {{ ip.ipNo }}
                                    td(width="100" class="headerTable") Divisi
                                    td {{ ip.ipDivisi }}
                                tr
                                    td(class="headerTable") Nama Pengawas Pengawalan
                                    td {{ ip.ipPengetahu ? ip.ipPengetahu.name : '' }}
                                    td(width="100" class="headerTable") Perusahaan
                                    td {{ ip.ipPerusahaan }}
                                tr
                                    td(class="headerTable") Suplier Unit
                                    td(colspan="3") {{ ip.ipSupplierUnit }}
                                tr
                                    td(class="headerTable" ) Jenis Kendaraan
                                    td(colspan="3") {{ ip.ipJenisKendaraan }}
                                tr
                                    td(class="headerTable" ) Model Kendaraan
                                    td(colspan="3") {{ ip.ipModelKendaraan }}
                                tr
                                    td(class="headerTable" ) Nomor Kendaraan
                                    td(colspan="3") {{ ip.ipNomorKendaraan }}
                        
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable" colspan="8") II. PERSYARATAN KHUSUS UNTUK PENCEGAHAN INSIDEN
                                tr
                                    td(colspan="8") Berikan tanda check pada kolom di bawah Baik (B) / Rusak (R) / Tidak Perlu (TP)
                                tr
                                    td(class="headerTable align-center") Daftar periksa
                                    td(class="align-center headerTable" width="40") B
                                    td(class="align-center headerTable" width="40") R
                                    td(class="align-center headerTable" width="40") TP
                                    td(class="headerTable align-center") Daftar periksa
                                    td(class="align-center headerTable" width="40") B
                                    td(class="align-center headerTable" width="40") R
                                    td(class="align-center headerTable" width="40") TP
                                tr
                                    td Kondisi kursi menurut standar pabrik, terpasang dengan aman
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKursi == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKursi == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKursi == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Safety bar / Rolling bar
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSafetyBar == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSafetyBar == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSafetyBar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr
                                    td Klakson, intensitas suara cukup memadai
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKlakson == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKlakson == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKlakson == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td Kaca spion dalam kondisi baik
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKacaSpion == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKacaSpion == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiKacaSpion == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr
                                    td Wiper depan dan pembersih kaca berfungsi dengan baik
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiWiper == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiWiper == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiWiper == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td APAR siap digunakan
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiApar == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiApar == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiApar == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                tr
                                    td Semua lampu berfungsi dengan baik
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiLampu == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiLampu == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiLampu == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(colspan="4")
                                tr
                                    td(colspan="8" class="headerTable autoPageBreak") Rem, steering, seat belt
                                tr
                                    td Rem kaki
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemKaki == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemKaki == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemKaki == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(colspan="4")
                                tr
                                    td Rem tangan
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemTangan == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemTangan == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiRemTangan == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(colspan="4")
                                tr
                                    td Sistem steering
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSistemSteering == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSistemSteering == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSistemSteering == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(colspan="4")
                                tr
                                    td Seat belt
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSeatBelt == 'Baik'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSeatBelt == 'Rusak'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(class="align-center")
                                        img(v-if="ip.ipKondisiSeatBelt == 'N/A'" class="verMiddle" src="../assets/check.png" width="10")
                                        v-flex(v-else) 
                                    td(colspan="4")
                                tr
                                    td(colspan="8" class="headerTable") Ban dan track dalam kondisi normal
                                tr
                                    td(colspan="8")
                                        v-row
                                            v-col
                                                AlteringCheckbox(label="BAN No.1" v-model="ip.ipBanStatus[0]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.2" v-model="ip.ipBanStatus[1]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.3" v-model="ip.ipBanStatus[2]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.4" v-model="ip.ipBanStatus[3]['status']" readOnly)
                                            v-col
                                                AlteringCheckbox(label="BAN No.5" v-model="ip.ipBanStatus[4]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.6" v-model="ip.ipBanStatus[5]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.7" v-model="ip.ipBanStatus[6]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.8" v-model="ip.ipBanStatus[7]['status']" readOnly)
                                            v-col
                                                AlteringCheckbox(label="BAN No.9" v-model="ip.ipBanStatus[8]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.10" v-model="ip.ipBanStatus[9]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.11" v-model="ip.ipBanStatus[10]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.12" v-model="ip.ipBanStatus[11]['status']" readOnly)
                                            v-col
                                                AlteringCheckbox(label="BAN No.13" v-model="ip.ipBanStatus[12]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.14" v-model="ip.ipBanStatus[13]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.15" v-model="ip.ipBanStatus[14]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.16" v-model="ip.ipBanStatus[15]['status']" readOnly)
                                            v-col
                                                AlteringCheckbox(label="BAN No.17" v-model="ip.ipBanStatus[16]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.18" v-model="ip.ipBanStatus[17]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.19" v-model="ip.ipBanStatus[18]['status']" readOnly)
                                                AlteringCheckbox(label="BAN No.20" v-model="ip.ipBanStatus[19]['status']" readOnly)

                        table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                            tbody(v-if="ip.ipAttachmentFiles.docPendukung") 
                                v-btn(tile text @click="download(ip.ipAttachmentFiles.docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                    tr
                                        td(style="padding-left:1px" ) 
                                            v-icon(small) mdi-attachment
                                        td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                        td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                            img(src="../assets/check.png" width="10" )
                            tbody(v-else)
                                tr
                                    td(style="padding-left:1px" ) 
                                        v-icon(small) mdi-attachment
                                    td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                    td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                        img(src="../assets/close.png" width="10" class="verMiddle")
                        
                        table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                            tbody
                                tr
                                    td(class="headerTable pl-2" colspan="6") III. PENGESAHAN
                                tr
                                    td(class="pl-2" colspan="6") 
                                        b Catatan:
                                        ul
                                        li 
                                            i Pengajuan internal BIB ditandatangani oleh pengawas area kerja & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                        li 
                                            i Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                                tr
                                    td(class="headerTable pl-2" rowspan="2" width="5%") Pengawas Pengawalan
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                tr
                                    td
                                        div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                            br
                                            | {{ ip.ipWorkflow[0].name }}
                                            br
                                        div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                            br
                                            | {{ ip.ipWorkflow[0].admin_reject == true ? ip.ipWorkflow[0].admin_detail.name : ip.ipWorkflow[0].name }}
                                            br
                                        div(v-else class="emptySign")
                                    td
                                        div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                            br
                                            | {{ ip.ipWorkflow[0].title }}
                                            br
                                        div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                            br
                                            | {{ ip.ipWorkflow[0].admin_reject == true ? 'Admin' : ip.ipWorkflow[0].title }}
                                            br
                                        div(v-else class="emptySign") {{ jabatanDetail(ip.ipWorkflow[0].postAs, 0, ip.ipForm) }}
                                    td
                                        div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                            br
                                            | {{approvalTime(ip.ipWorkflow[0].date)}}
                                            br
                                        div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                            br
                                            | {{approvalTime(ip.ipWorkflow[0].date)}}
                                            br
                                        div(v-else class="emptySign")
                                    td
                                        div(v-if="ip.ipWorkflow[0].status == 7" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else-if="ip.ipWorkflow[0].status == 8" class="approved")
                                            img(src="../assets/close-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
                                        p(v-if="ip.ipWorkflow[0].comment || ''" class="align-left top-align comment") {{ ip.ipWorkflow[0].comment }}
                                        div(v-else class="emptySign")
                                tr
                                    td(class="headerTable pl-2" rowspan="5" width="5%") Disetujui oleh
                                    td(class="headerTable align-center" width="20%") Nama
                                    td(class="headerTable align-center" width="20%") Jabatan
                                    td(class="headerTable align-center" width="20%") Tanggal
                                    td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                                tr
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPengaju ? ip.ipPengaju.name : '' }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPengaju ? ip.ipPengaju.title : '' }}
                                    td
                                        div(class="approved")
                                            br
                                            | {{ ip.ipPengaju ? approvalTime(ip.ipDate) : '' }}
                                    td
                                        div(v-if="ip.ipStatus != '1' && ip.ipStatus != '3' && ip.ipPengaju" class="approved")
                                            img(src="../assets/check-64.png" style="width:25px;")
                                        div(v-else class="emptySign")
                                    td
            
</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import AlteringCheckbox from './AlteringCheckbox.vue';
import { mapState } from 'vuex';
import printJS from 'print-js';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
export default {
  name: 'LampiranPengawalanViewEmail',
  components: {
      AlteringCheckbox,
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object,
    activeStatus: Number,
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: ''
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl", "dataUsers"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file, this.$route.params.token);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share, token: this.$route.params.token }).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        if (this.ip.ipStatus == 2 && this.activeStatus == 9) {
            for (const wf of this.ip.ipWorkflow) {
                if ((wf.status == 9) && (wf.approverId == this.approvalUser.nik)) {
                    return true;
                }
            }
        }
        return false
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    }
  },
  watch: {
    approvalDialog2 (val) {
        if (!val) return
        let formData = new FormData();
        formData.append('_id', this.ip._id);
        formData.append('status', parseInt(this.approval));
        formData.append('comment', this.comment);
        formData.append('approvalUser', JSON.stringify(this.approvalUser));
        
        formData.append('formCode', this.ip.ipForm);
        const sourceApproval = this.$route.query.sourceApproval || "";
        formData.append('sourceApproval', sourceApproval);
        const config = {
            method: "put",
            url: `${this.API_URL}/v1/requests/approvalAttachment`,
            headers: {"Authorization": `Bearer ${this.$route.params.token}`},
            data: formData
        };
        axios(config).then(res => {
            if (res.status == 200) {
                setTimeout(() => {
                    this.dialog2 = false;
                    this.dialog = false;
                    location.reload();
                },
                1000);
            }
        }).catch(error => {
            handleGlobalErrorApproval(error, {
                setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                showSnackbar: (show) => { this.snackbar = show; },
                closeModals: () => { 
                    this.approvalDialog = false; 
                    this.approvalDialog2 = false; 
                },
                disableLoader: () => { 
                    this.$store.state.loader = false;
                },
            });
        });
     
    }
    
  }
};
</script>
<style scoped>
.ck-editor__editable {
    min-height: 200px !important;
    max-height: 600px !important;
}
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.5;
}
.fontWatermarkUpLampiran {
  font-size:500%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.3;  
  right: 200px;
  color: gray;
}
.fontWatermarkDownLampiran {
  font-size:500%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.3;  
  top: 450px;
  right: 100px;
  color: gray;
}
</style>